module.exports = __webpack_public_path__ + "img/database.ca25ae75.svg";